<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Stores</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Stores
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <div>
                        <h4>Stores</h4>
                    </div>
                    <div class="d-flex align-items-center">
                        <download-excel
                            ref="exporter-csv"
                            v-show="false"
                            type="csv"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="'Stores_Report.csv'"
                        />
                        <download-excel
                            ref="exporter-xls"
                            v-show="false"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="'Stores_Report.xls'"
                        />
                        <a href="#" @click.prevent="exportTableData('admin.stores.index', {}, 'csv')" class="export-link mr-2">
                            <i class="fas fa-file-csv"></i> Export to CSV
                        </a>
                        <a href="#" @click.prevent="exportTableData('admin.stores.index', {}, 'xls')" class="export-link text-warning mr-2">
                            <i class="fa fa-file-excel-o"></i> Export to Excel
                        </a>
                        <a href="/export-stores" download class="btn btn-sm btn-primary glow mb-1 mb-sm-0">
                            Download Stores Catalog
                        </a>
                    </div>
                </div>

                <div class="card-body">
                    <form>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Store Name</label>
                                    <input name="search" id="category" class="form-control form-control-sm"
                                           type="text"
                                           v-model="filters.name">
                                    <template v-if="errors.name">
                                        <small class="text-danger" v-for="error in errors.name">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Address</label>
                                    <input name="order_no" id="category" class="form-control form-control-sm"
                                           type="text"
                                           v-model="filters.area">
                                    <template v-if="errors.area">
                                        <small class="text-danger" v-for="error in errors.area">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By State</label>
                                    <select name="store" class="form-control form-control-sm"
                                            v-model="filters.state">
                                        <option :value="null" :selected="filters.state==null">All</option>
                                        <option v-for="state in states" :key="state.id"
                                                :value="state.id">
                                            {{ state.name }}
                                        </option>
                                    </select>
                                    <template v-if="errors.state">
                                        <small class="text-danger" v-for="error in errors.state">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">Sort By Inventory Count</label>
                                    <select name="store" class="form-control form-control-sm"
                                            v-model="filters.low_inventory_count">
                                        <option :value="null" :selected="filters.low_inventory_count==null">No Sort</option>
                                        <option :value="'asc'" :selected="filters.low_inventory_count==='asc'">Lowest to Highest</option>
                                        <option :value="'desc'" :selected="filters.low_inventory_count==='desc'">Highest to Lowest</option>
                                    </select>
                                    <template v-if="errors.low_inventory_count">
                                        <small class="text-danger" v-for="error in errors.inventory_count">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Status</label>
                                    <select name="store" class="form-control form-control-sm"
                                            v-model="filters.status">
                                        <option :value="null">All</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                    <template v-if="errors.state">
                                        <small class="text-danger" v-for="error in errors.state">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>

                            <div class="col-md-12 mb-2">
                                <label>&nbsp;</label>
                                <br>
                                <button type="submit" @click.prevent="paginatedData"
                                        class="btn btn-primary glow mb-1 mb-sm-0">Apply Filter
                                </button>
                                <button type="reset" @click.prevent="resetFilters"
                                        class="btn btn-warning glow mb-1 mb-sm-0">
                                    Reset Filter
                                </button>
                            </div>
                        </div>
                    </form>

                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allStores"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'low_inventory_count'">
                                Count: {{ props.row.low_inventory_count }}
                                <br>
                                Percentage: {{ props.row.low_inventory_percentage }}%
                                <br>
                                <span v-if="props.row.low_inventory_percentage >= 70" class="badge badge-danger">
                                    ⚠ Low Inventory Alert
                                </span>
                            </span>
                            <span v-else-if="props.column.field === 'is_opened'">
                                <template v-if="props.row.is_opened">
                                    <span class="badge badge-glow badge-success">Yes</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">No</span>
                                </template>
                            </span>
                            <span v-else-if="props.column.field === 'is_active'">
                                <template v-if="props.row.is_active">
                                    <span class="badge badge-glow badge-success">active</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">inactive</span>
                                </template>
                            </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <Link :href="route('admin.stores.details', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-eye"></i>
                                    View
                                </Link>
                                <Link :href="route('admin.stores.edit', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </Link>
                                <a :href="frontend_url + '/menu/'+ props.row.state.name+'/'+props.row.slug"
                                   target="_blank"
                                   class="dropdown-item">
                                    <i class="feather icon-list"></i>
                                    View Menu
                                </a>
                                <a :href="route('admin.stores.toppings', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-list"></i>
                                    View Toppings
                                </a>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import TableExportMixin from "../../Shared/Mixins/TableExportMixin";

export default {
    metaInfo: {title: 'Stores'},
    props: ['stores', 'states', 'frontend_url'],
    layout: Layout,
    components: {
        Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
        TableExportMixin,
    ],
    data: () => ({

        filters: {
            name: null,
            area: null,
            state: null,
            low_inventory_count: null,
            status: null,
        },
        errors: {},
        isLoadingFilter: false,
        allStores: [],
        exportRows: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },

        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },

        sortingOptions: {
            enabled: false,
        },

        columns: [
            {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Store Name', field: 'name', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Store Address', field: 'area', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'City', field: 'city_name', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'State', field: 'state_name', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Longitude', field: 'longitude', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Latitude', field: 'latitude', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Opened', field: 'is_opened', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Low Inventory Count', field: 'low_inventory_count', thClass: 'text-center', tdClass: 'text-center'},
            // {label: 'Opening Time', field: 'opening_time', thClass: 'text-center', tdClass: 'text-center'},
            // {label: 'Closing Time', field: 'closing_time', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Status', field: 'is_active', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
    }),

    computed: {
        exportFields() {
            return this.buildExportFieldsFromColumns(this.columns);
        },
    },

    mounted() {
        this.allStores = this.stores.data;
        this.totalRecords = this.stores.total
        const urlParams = new URLSearchParams(window.location.search);
        console.log(urlParams)
        if ((urlParams.get('sortby') ?? '') === 'low_inventory_count') {
            try {
                this.filters.low_inventory_count = 'desc';
                this.paginatedData();
            } catch (e) {
                console.error("Invalid sort query param", e);
            }
        }
    },

    methods: {
        async paginatedData() {
            try {
                let routeName = 'admin.stores.index';

                let response = await axios.get(route(routeName), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true,
                        ...this.filters
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allStores = response.data.data
            } catch (e) {
                console.log(e);
            }
        },
        async deleteStore(id) {
            this.$inertia.delete(route('admin.stores.delete', id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.paginatedData();
                }
            })
        },
        async resetFilters() {
            for (let filter in this.filters) {
                this.filters[filter] = null;
            }
            await this.paginatedData();
        },
        async showAlert(storeId) {
            const details = {
                title: "Are you sure you want to delete this store?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteStore(storeId) : "";
        },
    }
}
</script>
